import React from 'react';
import './Header.css';

function Header() {
    return (
        <>
            <div className="header">
                <ul className="header_list">
                    <li className="header_list_options">Vedic Maths &gt; </li>
                    <li className="header_list_options">Unit-1 &gt; </li>
                    <li className="header_list_options">Welcome to this Course</li>
                </ul>
            </div>
        </>
    )
}

export default Header
